import React, { useEffect } from 'react';
import FacilityPage from '../components/FacilityPage';

const CorporateEvent: React.FC = () => {
  useEffect(() => {
    document.body.className = 'bg-dark';
    return () => {
      document.body.className = '';
    };
  }, []);
  return (
    <FacilityPage
      title="Corporate Event"
      description="We work closely with our clients to understand their specific needs and goals. Our corporate event services are designed to create professional, memorable experiences that reflect your company's values and objectives. From business meetings to product launches, we provide the perfect venue and services."
      features={[
        "Professional event planning services",
        "State-of-the-art AV equipment",
        "Flexible seating arrangements",
        "Catering services available",
        "Dedicated event coordinators",
        "High-speed WiFi connectivity",
        "Parking facilities",
        "Customizable event packages"
      ]}
      images={["/images/facilities/restro.jpg"]}
    />
  );
};

export default CorporateEvent;